var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-item',{staticClass:"q-pa-xs"},[_c('q-input',{staticClass:"bg-white col",attrs:{"value":_vm.value,"label":_vm.label,"outlined":"","stack-label":"","label-color":"black","readonly":"","autogrow":"","dense":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }